import { gql } from '@apollo/client';

export const CREATE_TERMINAL_CONNECTION_TOKEN = gql`
  mutation CreateTerminalConnectionToken {
    CreateTerminalConnectionToken {
      secret
    }
  }
`;
